import Image from 'next/image'

import CustomerStoryWithTiles from '@/components/CustomerStoryWithTiles'

const VestreCustomerStory = () => {
    return (
        <CustomerStoryWithTiles
            light={false}
            backgroundImage={'/images/customer-quotes/vestre-story-desktop.png'}
            mobileBackgroundImage={'/images/customer-quotes/vestre-story-mobile.png'}
            logo={
                <Image
                    src={'/images/logos/vestre.png'}
                    height={32}
                    width={129.28}
                    alt={'Vestre customer story'}
                />
            }
            text={
                <>
                    After establishing its Net Zero strategy, Vestre wanted to neutralise
                    unavoidable emissions.
                    <br />
                    <br />
                    They chose to purchase only permanent carbon removal, guaranteeing carbon will
                    be safely stored for thousands of years.
                </>
            }
            button={{
                label: 'Vestre’s sustainability page',
                href: 'https://sustainability.lune.co/vestre-as',
                target: '_blank',
            }}
        />
    )
}

export default VestreCustomerStory
